import { Link } from "react-router-dom";
import { BuildInfo } from "./build-info";

export function Brand() {
  return (
    <header className="brand">
      <Link to="/" className="brand__title">
        Quizshow Studio
      </Link>
      <span className="brand__meta">A NexVerse Project</span>
      <BuildInfo />
    </header>
  );
}
